/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-07 12:49:30
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-11 15:20:50
 * @FilePath: \senlan-ai-ui\src\pages\login\components\LoginForm.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { useState } from 'react'
import { Form, Input, Button, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { loginApi } from '@/api/modules/login.ts'
import { HOME_PATH } from '@/config/index.ts'
import { notification } from '@/hooks/useMessage.ts'
import { useUserActions } from '@/hooks/useUser.ts'

const LoginForm = ({ loginBefore }: any) => {
  const navigate = useNavigate()

  const { user, pass } = JSON.parse(localStorage.getItem('AIaccount') ?? '{}')
  const [loading, setLoading] = useState(false)
  const { userInfo } = useUserActions();


  const userLogin = async (values: any) => {
    const { username, password } = values
    setLoading(true)

    loginBefore()

    await loginApi({ username, password })
      .then((res) => {
        localStorage.setItem(import.meta.env.VITE_TOKEN_KEY, res.data)
        localStorage.setItem(
          'AIaccount',
          JSON.stringify({ user: username, pass: password })
        )
        notification.success({
          message: '登录成功',
          description: `欢迎回来，${userInfo.name}！`,
          duration: 2,
        })
        navigate(HOME_PATH)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (

    <Form
      layout="vertical"
      onFinish={userLogin}
      autoComplete="off"
      initialValues={{
        username: user,
        password: pass,
      }}
      style={{ padding: "0 12px " }}
    >
      <Form.Item
        name="username"
        rules={[{ required: true, message: '请输入用户名' }]}
      >
        <Input prefix={<UserOutlined />} size="large" />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[{ required: true, message: '请输入密码' }]}
      >
        <Input.Password prefix={<LockOutlined />} size="large" />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          block
          loading={loading}
        >
          登录
        </Button>

      </Form.Item>

    </Form>
  )
}

export default LoginForm
